import { render, staticRenderFns } from "./projects-listing.vue?vue&type=template&id=f96102b8&scoped=true&"
import script from "./projects-listing.vue?vue&type=script&lang=js&"
export * from "./projects-listing.vue?vue&type=script&lang=js&"
import style0 from "./projects-listing.vue?vue&type=style&index=0&id=f96102b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96102b8",
  null
  
)

export default component.exports